<template>
  <div class="highlight-toast-parts">
    <p class="highlight-toast-parts__message">
      {{ $tc('RaceVideoPage.highlights.block.toast.message', 0, { name: userName }) }}
    </p>
    <atom-button
      class="highlight-toast-parts__button"
      :linkText="$tc('RaceVideoPage.highlights.block.toast.buttonLabel')"
      @onClick="handleCancelClicked"
    />
    <button class="highlight-toast-parts__close-button" @click="handleCloseClicked">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.7">
          <path
            d="M16.5856 6H19.414L13.414 12.0001L19.4139 18L16.5855 18L11.9997 13.4143L7.41403 18L4.5856 18L10.5855 12.0001L4.58545 6H7.41388L11.9997 10.5859L16.5856 6Z"
            fill="white"
          />
        </g>
      </svg>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AtomButton from '@/components/atoms/AtomButton.vue'

export default defineComponent({
  name: 'HighlightToastParts',
  components: { AtomButton },
  props: {
    userName: {
      type: String,
      required: true,
    },
  },
  setup(_, { emit }) {
    const handleCancelClicked = () => {
      emit('onClickCancel')
    }
    const handleCloseClicked = () => {
      emit('onClickClose')
    }
    return {
      handleCancelClicked,
      handleCloseClicked,
    }
  },
})
</script>

<style scoped lang="scss">
.highlight-toast-parts {
  position: fixed;
  bottom: 43px;
  right: 72px;
  z-index: 1000;
  width: calc(100% - 80px);
  max-width: 295px;
  padding: 10px;
  color: $white;
  background-color: rgba(#00dba6, 0.8);
  border-radius: 8px;

  .race-video-page--landscape-primary &,
  .race-video-page--landscape-secondary & {
    bottom: 228px;
  }

  &__message {
    padding-right: 30px;
    font-size: 12px;
    line-height: 1.6;
    word-break: break-all;
  }

  &__button {
    width: 100%;
    max-width: 275px;
    height: 28px;
    margin-top: 12px;
  }

  &__close-button {
    position: absolute;
    top: 2px;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    opacity: 0.5;
  }
}
</style>
